import { render, staticRenderFns } from "./HelpGuiasDialog.vue?vue&type=template&id=70edf610&scoped=true&"
import script from "./HelpGuiasDialog.vue?vue&type=script&lang=js&"
export * from "./HelpGuiasDialog.vue?vue&type=script&lang=js&"
import style0 from "./HelpGuiasDialog.vue?vue&type=style&index=0&id=70edf610&prod&scoped=true&lang=css&"
import style1 from "./HelpGuiasDialog.vue?vue&type=style&index=1&id=70edf610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70edf610",
  null
  
)

export default component.exports